module.exports = __webpack_public_path__ + "img/help_register_hfp@3x.1d9a6e2e.png";